/* eslint-disable react/prop-types */
import { WidgetCommonHorizontalContainer } from "@/components/widgets/WidgetCommonContainer"
import { WidgetWrapper } from "./WidgetWrapper"

import EmptyView from "@/components/EmptyView"
import UserCircle from "phosphor-react-native/src/icons/UserCircle"
import { BFColors } from "@/constants/Colors"
import { router } from "expo-router"

export default function QualificationWidget() {
  function onPress() {
    router.push("/account/qualification")
  }

  return (
    <WidgetWrapper
      category="preapproval"
      orientation="horizontal"
      title={"Profile"}
      onPress={onPress}
    >
      <WidgetCommonHorizontalContainer
        IconComponent={() => <UserCircle color={BFColors.teal} size={32} />}
        ImageComponent={EmptyView}
        subTitle={"Profile 75% complete"}
        ctaText={"Fill out your profile to see updated loan products"}
        layoutType={"short"}
      />
    </WidgetWrapper>
  )
}
